module.exports = __webpack_public_path__ + "img/9.37e74aa6.jpg";